import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/productionLog/arrow.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6aea03b6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "flex flex-column"
};
var _hoisted_2 = {
  class: "num flex align-center"
};
var _hoisted_3 = {
  class: "desc"
};
var _hoisted_4 = {
  class: "ml-auto flex mr-2 align-end"
};
var _hoisted_5 = {
  class: "status"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "planPart",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.toPlanDetail && _ctx.toPlanDetail.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(_ctx.emptyStringFormat(_ctx.data.num)), 1)]), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(_ctx.data.desc)), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.data.proportion) + "%", 1)]), _hoisted_6]);
}